import classNames from 'classnames';
import { stringify } from 'qs';
import { useMemo } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { Button, Figure, Heading } from 'yoso';
import { T } from '~/components/I18n';
import { NftCard } from '~/components/Nft';
import { Progress } from '~/components/Progress';
import { Evolution } from '../../Evolve.hooks';
import styles from './EvolutionStatusCard.module.scss';
export type EvolveStatusCardProps = Evolution;

export const EvolutionStatusCard = ({
  tokenType,
  growth,
  evolvedGrowth,
  nftAmount,
  minNftAmount,
  contentsUrl,
  thumbnailUrl,
}: EvolveStatusCardProps) => {
  const canEvolve = nftAmount >= minNftAmount;
  const hasFriend = nftAmount > 0;
  const description = useMemo(() => {
    if (canEvolve) return <T name="citizen_evolve_ready_done" options={[evolvedGrowth]} />;
    else if (nftAmount > 0) return <T name="citizen_evolve_ready_yet" options={[evolvedGrowth]} />;
    else return <T name="citizen_evolve_ready_non" />;
  }, [canEvolve, evolvedGrowth, nftAmount]);
  return (
    <NftCard className={styles.root} direction="row" size="medium">
      <div className={classNames('card-header', styles.header)}>
        <Figure className={styles.image} src={hasFriend ? contentsUrl : thumbnailUrl} />
      </div>
      <div className={classNames('card-body', styles.body)}>
        <Heading level={5} className={styles.title}>
          {growth}
        </Heading>
        <p className={styles.description}>{description}</p>
        {hasFriend && (
          <Progress
            className={styles.progress}
            max={minNftAmount}
            value={nftAmount}
            bubble={false}
          />
        )}
        {hasFriend ? (
          <Button<LinkProps>
            as={Link}
            to={`/membership/item/friend/levelup/go?tokenType=${tokenType}`}
            className={styles.button}
            size="small"
            color={canEvolve ? 'primary' : 'default'}>
            <T
              name={canEvolve ? 'citizen_button_title_evolve' : 'citizen_button_title_seedetails'}
            />
          </Button>
        ) : (
          <Button
            as="a"
            href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/marketplace?${stringify({
              collectibleId: 2,
              properties: { Growth: [growth] },
            })}`}
            className={styles.button}
            color="default"
            size="small">
            <T name="citizen_button_title_marketplace" />
          </Button>
        )}
      </div>
      {hasFriend && (
        <div className={styles.footer}>
          <span className={styles.count}>{nftAmount + '/' + minNftAmount}</span>
        </div>
      )}
    </NftCard>
  );
};
